import { useState } from 'react'

import type { LayoutMode } from '../types'

const STORAGE_KEY = 'gallery-layout-mode'

function getInitialMode(): LayoutMode {
  const stored = localStorage.getItem(STORAGE_KEY)
  if (stored === 'masonry' || stored === 'grid' || stored === 'large') {
    return stored
  }
  return 'masonry'
}

export function useLayoutMode() {
  const [layoutMode, setLayoutModeState] = useState<LayoutMode>(getInitialMode)

  const setLayoutMode = (mode: LayoutMode) => {
    setLayoutModeState(mode)
    localStorage.setItem(STORAGE_KEY, mode)
  }

  return { layoutMode, setLayoutMode }
}
